import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import V56BucketList from "./modules/v56_cloud_storage/v56BucketList";
import V56AccessList from "./modules/v56_cloud_storage/v56AccessList";
import {atom} from "recoil";
import V56Dashboard from "./containers/v56-dashboard";

export const buckets_ = atom({
    key: 'buckets_',
    default: [],
});

export const profileComplete_ = atom({
    key: 'profileComplete_',
    default: false,
});

export const haveNotifications_ = atom({
    key: 'haveNotifications_',
    default: false,
});

export const activeBucket_ = atom({
    key: 'activeBucket_',
    default: null,
});

export const loadingText_ = atom({
    key: 'loadingText_',
    default: '',
});

export const firstName_ = atom({
    key: 'firstName_',
    default: '',
});
export const lastName_ = atom({
    key: 'lastName_',
    default: '',
});

export const currPage_ = atom({
    key: 'currPage_',
    default: 'buckets',
});

export const selectedProfileBuckets_ = atom({
    key: 'selectedProfileBuckets_',
    default: [],
});

export const profileBucketSettings_ = atom({
    key: 'selectedProfileBucketSettings_',
    default: {},
});

export const selectedProfileVDrives_ = atom({
    key: 'selectedProfileVDrives_',
    default: [],
});

export const selectedProfileReadOnlyVDrives_ = atom({
    key: 'selectedProfileReadOnlyVDrives_',
    default: [],
});

export const contactInformation = atom({
    key: 'contactInformation',
    default: [],
});

export const vdrives = atom({
    key: 'vdrives',
    default: [],
});

export const profiles = atom({
    key: 'profiles',
    default: [],
});


function App() {
  return (
      <BrowserRouter>
        <Routes>
            <Route path="/storage" element={<V56Dashboard showComp={'buckets'}/>} />
          <Route path="/storage/vdrive" element={<V56Dashboard showComp={'vdrive'}/>} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
